module.exports = __webpack_public_path__ + "img/card_cityanalyticsmobility_background.17c3262b.png";